import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Button from 'components/shared/button';
import Heading from 'components/shared/heading';

import VolumeControl from 'icons/volume-control.inline.svg';
import useVideo from 'hooks/use-video';
import shape from './svg/shape.svg';

import styles from './home-hero-with-video.module.scss';

const cx = classNames.bind(styles);

const HomeHeroWithVideo = ({
  title,
  description,
  buttontext,
  buttonurl,
  video,
  buttonMuteText = 'enable audio',
}) => {
  const { videoWrapperRef, videoRef, isUnmuteVisible, isVideoMuted, unmute, handleVideoEnd } =
    useVideo();

  return (
    <section className={cx('wrapper')}>
      <div className="container">
        <div className={cx('inner')}>
          <div className={cx('left')}>
            <Heading className={cx('title')}>{title}</Heading>
            <p className={cx('description')}>{description}</p>

            <Button className={cx('button')} to={buttonurl} theme="accent-primary">
              {buttontext}
            </Button>
          </div>
          <div className={cx('video-wrapper')} ref={videoWrapperRef}>
            <div>
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video
                muted={isVideoMuted}
                controls={!isVideoMuted}
                playsInline
                onEnded={handleVideoEnd}
                ref={videoRef}
              >
                <source src={video} type="video/mp4" />
              </video>
              {isUnmuteVisible && (
                <Button
                  className={cx('button-mute')}
                  theme="primary"
                  size="sm"
                  data-type="video-mute-button"
                  onClick={unmute}
                >
                  <VolumeControl />
                  {buttonMuteText}
                </Button>
              )}
            </div>
          </div>
        </div>
        <img className={cx('shape')} src={shape} alt="" loading="lazy" aria-hidden />
      </div>
      <div className={cx('lines-wrapper')} aria-hidden />
    </section>
  );
};


HomeHeroWithVideo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttontext: PropTypes.string.isRequired,
  buttonurl: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired,
  buttonMuteText: PropTypes.string,
};

export default HomeHeroWithVideo;
